import { render, staticRenderFns } from "./collectStep1.vue?vue&type=template&id=345dfbbe&scoped=true"
import script from "./collectStep1.vue?vue&type=script&lang=ts"
export * from "./collectStep1.vue?vue&type=script&lang=ts"
import style0 from "./collectStep1.vue?vue&type=style&index=0&id=345dfbbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345dfbbe",
  null
  
)

export default component.exports